import { ButtonLink } from '_/components/ui/button-link'
import { LOCAL_HREFS } from '_/constants'

// Root 404, the SPA equivalent of the former Next not-found.tsx.
const NotFound = () => {
	return (
		<main className='flex min-h-dvh flex-col justify-center px-12 lg:px-24'>
			<div className='mx-auto my-auto max-w-3xl py-12 text-center lg:py-24'>
				<p className='font-journ-display text-journ-coral text-6xl/none text-base font-semibold'>404</p>
				<div className='mt-10 flex items-center justify-center gap-x-6'>
					<ButtonLink tone='outline' to={LOCAL_HREFS.HOME as never}>
						Back
					</ButtonLink>
				</div>
			</div>
		</main>
	)
}

export { NotFound }
